import React from 'react';

import { newOperationModel } from 'forms/newOperation';
import DoubleLeftLabelTextField from 'components/Fields/DoubleLeftLabelTextField';

const {
  stepOne: {
    firstName,
    lastName,
    document,
    documentType,
    borndate,
    tributaryKey,
    tributaryType,
    clientNumber,
    requestNumber,
    account,
    // hash,
    gender,
    maritalStatus,
    nationality,
    phone,
    mobilePhone,
    street,
    streetType,
    streetNumber,
    streetFloor,
    streetDepartament,
    state,
    country,
    sectorDate,
    email,
    deliverType,
    county,
    zipCode,
    // reject,
  },
} = newOperationModel;

function StepOne({ formProps, readOnly, id, ...rest }) {
  return (
    <fieldset disabled={readOnly} style={{ border: 0 }}>
      <DoubleLeftLabelTextField left={firstName} right={lastName} />
      <DoubleLeftLabelTextField left={document} right={documentType} />
      <DoubleLeftLabelTextField left={borndate} right={requestNumber} />
      <DoubleLeftLabelTextField left={tributaryKey} right={tributaryType} />
      <DoubleLeftLabelTextField left={clientNumber} right={account} />
      <DoubleLeftLabelTextField left={gender} right={nationality} />
      <DoubleLeftLabelTextField left={maritalStatus} right={sectorDate} />
      <DoubleLeftLabelTextField left={phone} right={mobilePhone} />
      <DoubleLeftLabelTextField left={email} right={deliverType} />
      <DoubleLeftLabelTextField left={street} right={streetNumber} />
      <DoubleLeftLabelTextField left={streetFloor} right={streetDepartament}/>
      <DoubleLeftLabelTextField left={county} right={state} />
      <DoubleLeftLabelTextField left={country} right={zipCode} />
      <DoubleLeftLabelTextField left={streetType} />
      {/* {parseInt(reject.code) && 
       <DoubleLeftLabelTextField left={reject}/> 
      <LeftLabelTextfield data={reject}/>} */}
    </fieldset>
  );
}

export default StepOne;
